import styled from 'styled-components'
import colors from '../../../tokens/colors'
import layout from '../../../tokens/layout'
import typography from '../../../tokens/typography'
import border from '../../../tokens/border'
import { defaultTheme } from '../../../theming/data/defaultTheme'
import { composeColorActive } from '../item/styles'
import { composeTheme } from '../../../utils/compose-theme'

interface ComponentProps {
  readonly active?: boolean
  readonly notification?: boolean
}

export const Submenu = styled.div.attrs((props) =>
  composeTheme(props),
)<ComponentProps>`
  font-weight: ${typography.fontWeight.fontWeightSemiBold};
  cursor: pointer;
  margin-left: ${layout.margin.spacingNano};
  display: ${(props) => (props.theme.collapsed ? 'none' : 'flex')};

  &:hover {
    color: ${(props) =>
      props.theme.brandColors
        ? props.theme.brandColors.primaryPure
        : colors.brandColorPrimaryPure};
    transition: color 0.25s;
  }
`

export const Title = styled.p`
  margin: ${layout.margin.spacingXxxs} ${layout.margin.spacingNone}
    ${layout.margin.spacingNano} ${layout.margin.spacingNone};
  font-weight: ${typography.fontWeight.fontWeightSemiBold};
  font-size: ${typography.fontSize.fontSizeXxs};
  font-style: normal;
  color: ${colors.neutralColorLowMedium};
  display: ${(props) => (props.theme.collapsed ? 'none' : 'flex')};
`
export const Container = styled.div`
  margin: ${layout.margin.spacingXxxs} ${layout.margin.spacingNone}
    ${layout.margin.spacingNano} ${layout.margin.spacingNone};
`

export const SubItem = styled.div.attrs((props) =>
  composeTheme(props),
)<ComponentProps>`
  display: flex;
  align-items: center;
  padding: ${layout.padding.spacingInsetNano} ${layout.padding.spacingInsetXs};
  text-align: center;
  color: ${(props) => {
    if (props.active) return composeColorActive(props)
    if (!props.theme.brandColors?.sideMenuFontColor)
      return colors.neutralColorLowPure
    return props.theme.brandColors.sideMenuFontColor
  }};
  border-left: ${border.width.widthThin} solid
    ${(props) => {
      if (props.active) return composeColorActive(props)
      return colors.neutralColorLowLight
    }};
  &:hover {
    color: ${(props) =>
      props.theme.brandColors
        ? props.theme.brandColors.primaryPure
        : colors.brandColorPrimaryPure};
    transition: color 0.25s;
  }
  &.is-disabled {
    color: ${colors.neutralColorLowMedium};
    cursor: not-allowed;
  }
`
Submenu.defaultProps = defaultTheme
SubItem.defaultProps = defaultTheme
Title.defaultProps = defaultTheme

export const Button = styled.button`
  border: ${border.width.widthNone};
  margin: ${layout.margin.spacingNone};
  padding: ${layout.padding.spacingInsetNone};
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  outline: none;
  width: 100%;
  cursor: pointer;

  align-items: center;
  color: inherit;
  display: flex;
  position: relative;
  text-decoration: none;

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }
`
export const WrapperNotification = styled.div.attrs((props) =>
  composeTheme(props),
)<ComponentProps>`
  background-color: ${(props) =>
    props.theme.brandColors
      ? props.theme.brandColors.primaryPure
      : colors.brandColorPrimaryPure};
  width: 0.8rem;
  height: 0.8rem;
  border-radius: ${border.radius.radiusCircular};
  margin-left: ${layout.margin.spacingXxxs};
`
